export default "__VITE_ASSET__DDJYjSxz__"